import { z } from 'zod';
import { SparkRequestState } from '../spark';

/**
 * Types for SparkBundle Retailers endpoint
 * Fetches list of retailers participating in a bundle
 */

export const getBundleRetailersPathParamsSchema = z.object({
  accountId: z.string().min(1), // Vendor account ID
  bundleId: z.string().min(1), // SparkBundle ID
});

export type GetBundleRetailersPathParams = z.infer<typeof getBundleRetailersPathParamsSchema>;

/**
 * Retailer summary for bundle retailers list view
 */
export interface BundleRetailer {
  /** Retailer account ID */
  id: string;
  /** Retailer name */
  name: string;
  /** Retailer logo URL (CloudFront CDN) */
  photo?: string;
  /** Request state for this retailer's spark in the bundle */
  requestState: SparkRequestState;
  /** Number of locations participating in this spark */
  locationCount: number;
  /** Number of employees participating in this spark */
  employeeCount: number;
  /** Number of qualifying products for this spark */
  qualifyingProductCount: number;
  /** The spark ID for this retailer in the bundle */
  sparkId: string;
}

export interface BundleRetailersResponseBody {
  data: BundleRetailer[];
}
